import PhoneNumber from 'awesome-phonenumber';

export default {
  data() {
    return {
      intlTelInputInstance: null,
      phoneNumberError: '',
      countryCode: '',
      defaultCountry: '',
    };
  },

  methods: {
    handleDefaultCountry() {
      if (navigator.languages && ['uk', 'ru'].every((code) => navigator.languages.includes(code))) {
        this.defaultCountry = 'ua';
        return;
      }
      let language =
        (navigator.languages && navigator.languages[0]) || // Chrome / Firefox
        navigator.language || // All browsers
        navigator.userLanguage
      if (language) {
        let isLanguage = language.split('-')[1];
        if (!isLanguage) {
          isLanguage = language.split('-')[0];
        }
        if (isLanguage) {
          this.defaultCountry = isLanguage;
        }
      }
    },

    handlePhoneNumberValidation(v) {
      if (!v) {
        this.phoneNumberError = 'This field is required';
        return;
      }

      const newValue = '+' + this.countryCode.dialCode + v;

      let regionCode = PhoneNumber(newValue).getRegionCode();

      const pm = new PhoneNumber(newValue, regionCode);

      if (pm && !pm.isValid()) {
        let possibility = pm.a.possibility;
        if (possibility !== 'unknown' && possibility !== 'is-possible') {
          if (possibility === 'invalid-country-code') {
            this.phoneNumberError = 'Invalid country code';
          } else {
            this.phoneNumberError = `Incorrect, fax number is ${
              (possibility.includes('-') && possibility.split('-').join(' ')) || possibility
            }`;
          }
        } else {
          this.phoneNumberError = 'Incorrect phone number format';
        }
      } else {
        this.phoneNumberError = '';
      }
    },
  },
}
